module.exports = __webpack_public_path__ + "static/Sophie_Green-7b68cab6e8c3e0b52de20bc82868e54c.png";